<template>
    <div>
        <x-panel margin class="mb-5" v-if="marketingPartner && _.has(referral_data, 'goals')">
            <div slot="title">
                <h3>Credit Concierge</h3>
            </div>
            <div slot="extra" :class="`d-flex justify-content-end`">
                <div v-if="target_low" class="px-2 leads-low d-flex justify-content-end align-items-center">
                    <small>Leads running low</small>
                    <el-button v-waves class="ml-2 filter-item" type="danger" size="small" @click="requestTargetTopup">
                        top up?
                    </el-button>
                </div>
            </div>
            <el-row :gutter="12" class="lead-stats">
                <el-col class="mb-2 ml-0 mr-0 col-12 col-sm-6 col-xl-3 mb-xl-0 box-card">
                    <el-card shadow="never">
                        <div slot="header" class="clearfix">
                            <span>Requested / Delivered</span>
                            <el-tag size="mini" type="success" style="float: right"
                                    @click="selectedChart = lineChartData.month">
                                This Month
                            </el-tag>
                        </div>
                        <div class="split-content">
                            <div class="left">
                                <h2>{{ referral_data.goals.monthly.requested }}</h2>
                            </div>
                            <div class="right">
                                <h2>{{ referral_data.goals.monthly.delivered }}</h2>
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col class="mb-2 ml-0 mr-0 col-12 col-sm-6 col-xl-3 mb-xl-0 box-card">
                    <el-card shadow="never">
                        <div slot="header" class="clearfix">
                            <span>Requested / Delivered</span>
                            <el-tag size="mini" type="warning" style="float: right"
                                    @click="selectedChart = lineChartData.today">Today
                            </el-tag>
                        </div>
                        <div class="split-content">
                            <div class="left">
                                <h2>{{ referral_data.goals.daily.requested }}</h2>
                            </div>
                            <div class="right">
                                <h2>{{ referral_data.goals.daily.delivered }}</h2>
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col class="mb-2 ml-0 mr-0 col-12 col-sm-6 col-xl-3 mb-xl-0 box-card">
                    <el-card shadow="never">
                        <div slot="header" class="clearfix">
                            <span>Avg. NAF</span>
                            <el-tag size="mini" type="info" style="float: right">This Month</el-tag>
                        </div>
                        <h2>
                            <sup>$</sup>
                            {{ averageNaf }}
                        </h2>
                    </el-card>
                </el-col>
                <el-col class="mb-2 ml-0 mr-0 col-12 col-sm-6 col-xl-3 mb-xl-0 box-card">
                    <el-card shadow="never">
                        <div slot="header" class="clearfix">
                            <span>Daily leads to hit monthly target</span>
                        </div>
                        <h2>{{ daily_target }}</h2>
                    </el-card>
                </el-col>
            </el-row>
        </x-panel>
        <!-- <el-row style="background: #fff; padding: 16px 16px 0; margin-bottom: 32px">
            <mix-chart :key="selectedChart" :chart-data="selectedChart ? selectedChart : lineChartData.month"/>
        </el-row> -->
        <x-panel margin>
            <div slot="title">
                <div class="d-flex justify-content-start align-items-center">
                    <el-button v-waves class="mr-2" @click="clearSelection()" size="small">Clear Selection</el-button>
                    <el-button v-waves class="mr-2" type="primary" @click="toggleFilters()" size="small"
                               icon="fas fa-filter">
                        Filters / Sort
                    </el-button>
                    <LeadsAutoAssigner button-size="small"/>
                    <el-button v-waves class="m-2" type="primary" size="small" @click="toggleLeadSocringModal()">
                        Lead Scoring
                    </el-button>
                </div>
            </div>
            <div slot="extra" :class="`d-flex justify-content-end`">
                <el-select
                    v-model="listFilters.opportunties"
                    placeholder="Status"
                    class="mr-2 filter-item"
                    size="small"
                    @change="handleFilter(true)"
                    @clear="handleFilter(true)"
                >
                    <el-option v-for="(option, value, index) in options" :key="index" :value="value"
                               :label="option"></el-option>
                </el-select>
                <el-input
                    v-model="listFilters.search"
                    placeholder="Enter Search..."
                    clearable
                    size="small"
                    @clear="handleFilter(true)"
                    style="width: 200px"
                    class="mr-2 filter-item"
                    @keyup.enter.native="handleFilter(true)"
                />
                <el-button v-waves class="mr-2 filter-item" type="primary" size="small" icon="el-icon-search"
                           @click="handleFilter(true)">
                    Search
                </el-button>
                <el-dropdown>
                    <el-badge :value="selectedLeads.length" :max="99" class="item" :hidden="selectedLeads.length == 0">
                        <el-button class="filter-item" style="color: green" size="small"
                                   @click="handleActionButtonClick">
                            Actions
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                    </el-badge>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="listFilters.opportunties == 'unassigned'"
                                          @click.native="showBrokerSelect()">
                            <span>Assign Selected</span>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="listFilters.opportunties != 'unassigned'"
                                          @click.native="unAssignSelectedLeads">
                            <span>Un-Assign Selected</span>
                        </el-dropdown-item>
                        <el-dropdown-item
                            v-if="listFilters.opportunties != 'unassigned' && viewAllTeams"
                            @click.native="unAssignAndRetractSelectedLeads"
                        >
                            <span>Un-Assign & Retract Selected</span>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="listFilters.opportunties != 'unassigned'"
                                          @click.native="showBrokerSelect()">
                            <span>Re-assign Selected</span>
                        </el-dropdown-item>
                        <el-dropdown-item type="danger" @click.native="closeApplications">
                            <span>Close Selected</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </x-panel>

        <el-alert
            class="my-3"
            v-if="viewAllTeams && _.get(Ambition, 'Globals.tenant.teams_enabled') && _.size(collection.data) == 0 && otherTeamsHasLeads && listFilters.opportunties == 'unassigned'"
            title="There are opportunities in another team. You can change your current team or use the filter button to view all teams to view the opportunities."
            type="info">
        </el-alert>

        <transition name="slide">
            <x-panel margin v-show="showFilters">
                <el-row>
                    <el-col :span="15">
                        <el-row type="flex" align="middle">
                            <h4 class="mx-2">Filters:</h4>
                            <el-cascader
                                v-model="listFilters.optionsSelected"
                                :options="mappedOptions"
                                :show-all-levels="true"
                                :props="{ multiple: true, checkStrictly: true, emitPath: false, expandTrigger: 'hover' }"
                                popper-class="report-columns-cascader"
                                placeholder="Select filters to apply..."
                                class="w-100"
                                clearable
                                @change="handleFilter(true)"
                                @clear="handleFilter(true)"
                                @remove-tag="handleFilter(true)"
                            ></el-cascader>
                        </el-row>
                    </el-col>
                    <el-col :span="9">
                        <el-row type="flex" align="middle" justify="end">
                            <h4 class="mx-2">Date Filter:</h4>
                            <el-date-picker
                                v-model="listFilters.range"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="To"
                                start-placeholder="Start date"
                                end-placeholder="End date"
                                :default-time="['00:00:00', '23:59:59']"
                                :picker-options="pickerOptions"
                                @change="handleFilter(true)"
                                @clear="handleFilter(true)"
                            ></el-date-picker>
                        </el-row>
                    </el-col>
                </el-row>
            </x-panel>
        </transition>
        <el-table
            :data="collection.data"
            style="width: 100%"
            v-loading="listLoading"
            fit
            class="lead-manager"
            ref="filterTable"
            row-key="id"
            border
            @selection-change="handleSelectionChange"
        >
            <el-table-column fixed="left" type="selection" :reserve-selection="true"
                             :selectable="selectable"></el-table-column>
            <el-table-column type="expand">
                <template slot-scope="scope">
                    <div class="fin-grid fin-grid-cols-2 fin-gap-2 fin-p-2">
                        <div
                            class="fin-grid xl:fin-grid-cols-2 lg:fin-grid-cols-2 md:fin-grid-cols-1 sm:fin-grid-cols-1 fin-gap-2">
                            <div class="">
                                <h4 class="fin-mb-2" v-if="scope.row.updated_at">Updated</h4>
                                <div class="fin-flex fin-items-center">
                                    <i class="el-icon-time fin-mr-2 fin-text-xl"></i>
                                    <span>{{ (scope.row.updated_at + "Z") | moment("DD/MM/YYYY LT") }}</span>
                                </div>
                            </div>
                            <div class="">
                                <h4 class="mb-2">Loan Type</h4>
                                <span>{{ loanTypeBadge(scope.row) }}</span>
                            </div>
                            <table class="table table-borderless">
                                <tr>
                                    <th>Asset</th>
                                    <td>{{ _.get(scope.row, "asset.name", "") }}</td>
                                </tr>
                                <tr>
                                    <th>Phone</th>
                                    <td>{{ _.get(scope.row, 'customer.phone', '') }}</td>
                                </tr>
                                <tr>
                                    <th>Email</th>
                                    <td>{{ _.get(scope.row, 'customer.email', '') }}</td>
                                </tr>
                            </table>
                            <table class="table table-borderless">
                                <tr>
                                    <th>Source</th>
                                    <td>{{ scope.row.campaign_source ? scope.row.campaign_source : "" }}</td>
                                </tr>
                                <tr>
                                    <th>Campaign</th>
                                    <td>{{ scope.row.campaign_name }}</td>
                                </tr>
                                <tr>
                                    <th>Medium</th>
                                    <td>{{ scope.row.campaign_medium }}</td>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <div class="fin-mb-3" v-if="_.size(_.get(scope.row, 'possible_duplicates')) > 0">
                                <h4 class="mb-2">Possible Duplicates</h4>
                                <div class="table-scrollbar table-wrapper-scroll-y">
                                    <table
                                        class="table table-borderless tableFixHead">
                                        <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="e in scope.row.possible_duplicates" :key="e.id">
                                            <td>
                                                <el-link :href="e.search_url" target="_blank">{{ e.full_name }}</el-link>
                                            </td>
                                            <td>{{ _.get(e, "email", "") }}</td>
                                            <td>{{ _.get(e, "phone", "") }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="" v-if="scope.row.previous_apps_count > 0">
                                <h4 class="mb-2">Other Apps</h4>
                                <div class="table-scrollbar table-wrapper-scroll-y">
                                    <table
                                        class="table table-borderless tableFixHead">
                                        <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Asset</th>
                                            <th>Amount</th>
                                            <th>Stage</th>
                                            <th>Assigned</th>
                                            <th>Status</th>
                                            <th>History</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="e in scope.row.previous_apps" :key="e.id">
                                            <td>
                                                <el-link :href="e.search_url" target="_blank">{{ e.ref_id }}</el-link>
                                            </td>
                                            <td>{{ _.get(e, "asset.name", "") }}</td>
                                            <td>{{ formatCurrency(_.get(e, "amount", "")) }}</td>
                                            <td>{{ _.get(e, "applicationStatus.name", "Lead") }}</td>
                                            <td>{{ _.get(e, "broker.full_name", "") }}</td>
                                            <td>
                                                <div class="fin-flex fin-flex-col fin-space-y-2">
                                                    <span>{{ _.get(e, "status") == 3 ? "Closed" : "Open" }}</span>
                                                    <span>{{ _.get(e, 'close_reason.name', '') }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class=" fin-flex fin-space-x-4">
                                                    <el-tooltip class="item" effect="dark" content="Add Note"
                                                                placement="bottom">
                                                        <el-popover
                                                            v-if="e.last_note != null"
                                                            placement="top"
                                                            :title="e.last_note.notes"
                                                            width="auto"
                                                            popper-class="max-400"
                                                            trigger="hover"
                                                            :content="(e.last_note.updated_at + 'Z') | moment('DD/MM/YYYY LT')"
                                                        >
                                                            <el-button
                                                                slot="reference"
                                                                @click.prevent="createNote(e)"
                                                                icon="el-icon-edit"
                                                                circle
                                                                size="mini"
                                                                class="ml-2 note"
                                                                type="warning"
                                                            ></el-button>
                                                        </el-popover>
                                                        <el-button
                                                            v-else
                                                            icon="el-icon-edit"
                                                            @click.prevent="createNote(e)"
                                                            circle
                                                            size="mini"
                                                        ></el-button>
                                                    </el-tooltip>

                                                    <el-tooltip
                                                        v-if="Ambition.getGlobal('tenant.pbx_active')"
                                                        class="item" effect="dark" content="Call History"
                                                        placement="bottom">
                                                        <el-popover
                                                            placement="top"
                                                            width="auto"
                                                            popper-class="max-400"
                                                            trigger="hover">
                                                            <table v-if="_.get(e, 'call_history.0')"
                                                                class="table mb-0 mini">
                                                                <tbody>
                                                                <tr v-for="call in e.call_history" :key="call.id">
                                                                    <td>
                                                                        <strong>{{
                                                                                call.created_at + "Z" | moment("ddd DD/MM/YY LT")
                                                                            }}</strong></td>
                                                                    <td v-html="call.message"></td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                            <div v-else>No Calls Available</div>
                                                            <el-button @click.prevent="" slot="reference"
                                                                    icon="el-icon-phone"
                                                                    circle size="mini" class="mx-2"
                                                                    :type="checkSameDay(_.get(e, 'contacted.datetime')) ? _.get(e, 'contacted.status', 'danger') : 'danger'"></el-button>
                                                        </el-popover>
                                                    </el-tooltip>
                                                    <el-tooltip class="item" effect="dark" content="History"
                                                                placement="bottom">
                                                        <el-popover
                                                            :disabled="hover"
                                                            placement="top"
                                                            width="auto"
                                                            popper-class="max-400"
                                                            trigger="hover">
                                                            <table class="table mb-0 mini">
                                                                <tbody>
                                                                <tr v-if="_.get(e, 'created_at')">
                                                                    <td><strong>Created:</strong></td>
                                                                    <td>{{
                                                                            e.created_at | moment("ddd DD/MM/YY LT")
                                                                        }}
                                                                    </td>
                                                                </tr>
                                                                <tr v-if="_.get(e, 'updated_at')">
                                                                    <td><strong>Last Updated:</strong></td>
                                                                    <td>{{
                                                                            e.updated_at | moment("ddd DD/MM/YY LT")
                                                                        }}
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                            <div v-if="_.get(e, 'all_history')">
                                                                <h4 class="mt-2">Application History</h4>
                                                                <hr/>
                                                                <table class="table mb-0 mini">
                                                                    <tbody v-if="_.get(e, 'all_history')">
                                                                    <tr v-for="history in e.all_history"
                                                                        :key="history.id">
                                                                        <td>
                                                                            <strong>{{
                                                                                    (history.created_at + "Z") | moment("ddd DD/MM/YY LT")
                                                                                }}</strong>
                                                                        </td>
                                                                        <td v-html="history.message"></td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <el-button
                                                                @click.prevent=""
                                                                slot="reference"
                                                                icon="el-icon-time"
                                                                circle
                                                                size="mini"
                                                                class="mx-2"
                                                            ></el-button>
                                                        </el-popover>
                                                    </el-tooltip>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column min-width="250">
                <template slot-scope="scope">
                    <el-link :href="scope.row.search_url" target="_blank">{{ scope.row.ref_id }}</el-link>
                    <br/>
                    <span
                        v-if="_.get(Ambition, 'Globals.tenant.teams_enabled') && viewAllTeams && _.get(scope.row.team, 'name')">Team: {{
                            _.get(scope.row.team, "name")
                        }}</span><br
                    v-if="_.get(Ambition, 'Globals.tenant.teams_enabled') && viewAllTeams && _.get(scope.row.team, 'name')"/>
                    <span>Loan Type: {{ loanTypeBadge(scope.row) }}</span><br/>
                </template>
            </el-table-column>
            <el-table-column label="Name" min-width="250">
                <template slot-scope="scope">
					<span v-if="scope.row.customer" style="font-size: 13px; padding: 0 0.5rem">
						<strong>{{ scope.row.customer.full_name }}</strong>
					</span>
                    <br/>
                    <el-tag
                        size="mini"
                        v-if="_.get(scope.row, 'fast_tracked')"
                        type="danger"
                        class="m-0"
                    >
                        {{ "Hot Lead" }}
                    </el-tag>
                    <el-badge v-if="!_.get(scope.row, 'training', false)" :hidden="scope.row.previous_apps_count == 0"
                              :value="scope.row.previous_apps_count">
                        <el-tag
                            size="mini"
                            :type="scope.row.previous_apps_count > 0 ? 'info' : scope.row.fast_tracked == 1 ? 'danger' : 'success'"
                            class="m-0"
                        >
                            {{
                                scope.row.previous_apps_count > 0 ? "Prior / Existing Apps" : "New"
                            }}
                        </el-tag>
                    </el-badge>
                    <el-tag
                        v-if="_.get(scope.row, 'training', false)"
                        size="mini"
                        type="default"
                        class="m-0"
                    >Training Lead
                    </el-tag>
                    <el-tag
                        size="mini"
                        v-if="_.size(_.get(scope.row, 'possible_duplicates')) > 0"
                        type="danger"
                        class="m-0"
                    >
                        {{ "Possible Duplicate" }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="Contact Info" min-width="300">
                <template slot-scope="scope" v-if="scope.row.customer">
                    {{ scope.row.customer.phone }}
                    <br/>
                    {{ scope.row.customer.email }}
                    <br v-if="_.get(scope.row, 'postal_code')"/>
                    {{ _.get(scope.row, "postal_code") }}
                    <br v-if="_.get(scope.row, 'postal_code')"/>
                    {{ _.get(scope.row, "postal_code") }}
                    <br v-if="_.get(scope.row, 'aai.0.applicant.aai.addresses.0.administrative_area_level_1')"/>
                    <el-tag v-if="_.get(scope.row, 'aai.0.applicant.aai.addresses.0.administrative_area_level_1')"
                            size="small" type="info">
                        {{ _.get(scope.row, 'aai.0.applicant.aai.addresses.0.administrative_area_level_1') }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="amount" label="Amount" min-width="120" align="center">
                <template slot-scope="scope">
                    {{ formatCurrency(scope.row.amount) }}
                    <br v-if="_.has(scope.row, 'asset.name')"/>
                    <el-tag v-if="_.has(scope.row, 'asset.name')" size="small" type="info">
                        {{ _.get(scope.row, "asset.name", "") }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="Source" min-width="250" align="center">
                <template slot-scope="scope">
                    {{ _.get(scope.row, "sourceDetail.detail") }}
                    <br v-if="_.get(scope.row, 'source.name') && _.get(scope.row.sourceDetail, 'detail')"/>
                    <el-tag v-if="_.get(scope.row, 'source.name')" size="small" type="info">
                        {{ _.get(scope.row, "source.name") }}
                    </el-tag>
                    <br v-if="_.get(scope.row, 'campaign_source')"/>
                    <el-tag v-if="_.get(scope.row, 'campaign_source')" size="small" type="success">
                        {{ _.get(scope.row, "campaign_source") }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="Status" min-width="150" align="center">
                <template slot-scope="scope">
                    {{ _.get(scope.row.broker, "full_name") }}
                    <br v-if="_.has(scope.row.broker, 'full_name')"/>
                    <el-dropdown @command="setStatus" trigger="click">
						<span class="el-dropdown-link">
							<el-tag v-if="_.has(scope.row.broker, 'full_name')" size="small"
                                    type="success">{{ scope.row.status }}</el-tag>
							<el-tag v-else size="small" :type="leadStatuses[scope.row.status]">{{
                                    scope.row.status
                                }}</el-tag>
						</span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                                v-for="option in _.has(scope.row.broker, 'full_name') ? assignedOptions : unassignedOptions"
                                :key="option.action"
                                :command="{ action: option.action, row: scope.row }"
                            >
                                {{ option.label }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
            <el-table-column prop="referrer.name" label="Referrer" min-width="150" align="center">
                <template slot-scope="scope">
                    {{ _.get(scope.row.referrer, "user.full_name") }}
                    <br v-if="_.has(scope.row.referrer, 'user.full_name')"/>
                    <el-tag v-if="_.has(scope.row.referrer, 'name')" size="small" type="info">
                        {{ _.get(scope.row.referrer, "name") }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="lead_score" label="Lead Score" min-width="150" align="center">
                <template slot-scope="scope">
                    {{ scope.row.lead_score ? scope.row.lead_score : '' }}
                </template>
            </el-table-column>

            <el-table-column
                :label="listFilters.opportunties == 'assigned' ? 'History, Date &amp; Time' : 'Date &amp; Time'"
                :min-width="listFilters.opportunties == 'assigned' ? 200 : 150"
                align="center"
            >
                <template slot-scope="scope">
                    <el-popover
                        v-if="listFilters.opportunties == 'assigned' && _.get(scope.row, 'all_history')"
                        placement="top"
                        width="auto"
                        popper-class="max-400"
                        trigger="hover"
                    >
                        <table class="table mb-0 mini">
                            <tbody>
                            <tr v-if="scope.row.created_at">
                                <td><strong>Created:</strong></td>
                                <td>{{ (scope.row.created_at + "Z") | moment("ddd DD/MM/YY LT") }}</td>
                            </tr>
                            <tr>
                                <td><strong>Last Updated:</strong></td>
                                <td>{{ (scope.row.updated_at + "Z") | moment("ddd DD/MM/YY LT") }}</td>
                            </tr>
                            </tbody>
                        </table>

                        <div v-if="_.get(scope.row, 'all_history')">
                            <h4 class="mt-2">Application History</h4>
                            <hr/>
                            <table class="table mb-0 mini">
                                <tbody v-if="_.get(scope.row, 'all_history')">
                                <tr v-for="history in scope.row.all_history" :key="history.id">
                                    <td>
                                        <strong>{{ (history.created_at + "Z") | moment("ddd DD/MM/YY LT") }}</strong>
                                    </td>
                                    <td v-html="history.message"></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <el-button slot="reference" icon="el-icon-time" circle size="mini" class="mx-2"></el-button>
                    </el-popover>
                    {{ (scope.row.created_at + "Z") | moment("LT DD/MM/YYYY") }}
                </template>
            </el-table-column>
        </el-table>

        <pagination
            v-show="collection.total > 0"
            :total="collection.total"
            :page.sync="collection.current_page"
            :limit.sync="collection.per_page"
            @pagination="getCollection"
            :page-sizes="[10, 20, 30, 50, 100, 200, 500]"
        />

        <x-modal
            :wWidth="1100"
            :wHeight="550"
            v-if="selectBrokerModal"
            :footer="false"
            @cancel="closeBrokerModal()"
            @close="closeBrokerModal()"
            :draggable="true"
            okText="Continue"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`" style="flex-grow: 1;">
                {{ leadAction.name == "assign" ? "Assign" : "Re-assign" }}
            </div>
            <div slot="extra">
                <el-select size="mini"
                           v-show="_.get(Ambition, 'Globals.tenant.teams_enabled') && activeTab == 'brokers' && !_.get(Ambition, 'Globals.tenant.currentTeamId')"
                           v-model="leadAction.team" placeholder="team" value-key="id" clearable filterable>
                    <el-option v-for="team in filteredTeams" :key="team.id" :value="team.id"
                               :label="team.name"></el-option>
                </el-select>
            </div>

            <el-tabs v-model="activeTab">
                <el-tab-pane label="Brokers" name="brokers">
                    <brokers-assign
                        v-show="activeTab == 'brokers'"
                        :action.sync="leadAction"
                        :leads="selectedLeads"
                        :applicationId="selectedLeads"
                        :brokers="filteredBrokers"
                        @assign="submitAction(true)">
                    </brokers-assign>
                </el-tab-pane>
                <el-tab-pane label="Teams" name="teams"
                             v-if="_.get(Ambition, 'Globals.tenant.teams_enabled') && !_.get(Ambition, 'Globals.tenant.currentTeamId')">
                    <teams-assign
                        v-show="activeTab == 'teams'"
                        :action.sync="leadAction"
                        :leads="selectedLeads"
                        @assign="submitAction(true)">
                    </teams-assign>
                </el-tab-pane>
                <el-tab-pane label="Partners" name="partners"
                             v-if="_.get(Ambition, 'Globals.tenant.enable_lead_partner')">
                    <partners-assign
                        v-show="activeTab == 'partners'"
                        :action.sync="leadAction"
                        :leads="selectedLeads"
                        @assign="submitAction(true)">
                    </partners-assign>
                </el-tab-pane>
                <el-tab-pane label="Zaps" name="zaps">
                    <zaps-assign
                        v-show="activeTab == 'zaps'"
                        :action.sync="leadAction"
                        :leads="selectedLeads"
                        @assign="submitAction(true)">
                    </zaps-assign>
                </el-tab-pane>
            </el-tabs>
        </x-modal>

        <!-- start close app modal -->
        <close-application-modal
            :visible.sync="closeApplicationModalVisibility"
            :application-ids="checked"
            :lead-management-tab="true"
        ></close-application-modal>
        <!-- end close app modal -->

        <x-modal
            :wWidth="400"
            v-if="dailyTargetModal === true"
            @cancel="dailyTargetModal = false"
            @close="dailyTargetModal = false"
            @ok="handleDailyTarget"
            @okSecondary="handleDailyTarget"
            :draggable="true"
            okText="Continue"
            okSecondaryType="danger"
            okSecondaryText="Request Topup and Continue"
            :hideOkSecondary="!(dailyTarget.leads > remaining_leads && referral_data.workingDaysLeft > 1)"
            :okSecondaryDisabled="Number(dailyTarget.monthlyTopup) < Number(dailyTarget.leads) - remaining_leads"
            :hideOk="dailyTarget.leads > remaining_leads && referral_data.workingDaysLeft > 1"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">Daily Target</div>
            <el-form :model="dailyTarget">
                <el-row :gutter="10">
                    <el-col :span="24">
                        <el-form-item label="Request leads for tomorrow">
                            <el-input
                                type="number"
                                ref="dailyTarget"
                                v-model="dailyTarget.leads"
                                placeholder="How many leads would you like?"
                            ></el-input>
                            <small>({{ remaining_leads }} remaining this month)</small>
                        </el-form-item>
                        <el-alert
                            :closable="false"
                            v-if="dailyTarget.leads > remaining_leads"
                            :title="`You're trying to request more leads then you currently have left for the month, you require a further ${
								dailyTarget.leads - remaining_leads
							} leads to meet your request.`"
                            type="error"
                        ></el-alert>
                        <el-form-item v-if="dailyTarget.leads > remaining_leads" label="Need a lead top up?">
                            <el-input
                                type="number"
                                v-model="dailyTarget.monthlyTopup"
                                placeholder="How many extra leads would you like?"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </x-modal>

        <x-modal
            :wWidth="400"
            v-if="monthlyTargetModal === true"
            @cancel="monthlyTargetModal = false"
            @close="monthlyTargetModal = false"
            @ok="handleMonthlyTarget"
            :draggable="true"
            okText="Continue"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">Monthly Target</div>
            <el-form :model="monthlyTarget">
                <el-row :gutter="10">
                    <el-col :span="24">
                        <el-form-item label="Update leads for next month">
                            <el-input
                                type="number"
                                ref="monthlyTarget"
                                v-model="monthlyTarget.leads"
                                placeholder="Whats your lead goal?"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </x-modal>

        <x-modal
            :wWidth="400"
            v-if="requestTargetModal === true"
            @cancel="requestTargetModal = false"
            @close="requestTargetModal = false"
            @ok="handleTargetTopup"
            :draggable="true"
            okText="Continue"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">Monthly Target Topup</div>
            <el-form :model="monthlyTopupTarget">
                <el-row :gutter="10">
                    <el-col :span="24">
                        <el-form-item label="Request leads topup for current month">
                            <el-input
                                type="number"
                                ref="monthlyTopupTarget"
                                v-model="monthlyTopupTarget.leads"
                                placeholder="How many extra leads would you like?"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </x-modal>

        <lead-scoring-modal
            :applications="applicationToScore"
            :lead-scoring="leadScoring"
            :visible.sync="leadScoringModalVisible"
            :sources="sources"></lead-scoring-modal>
    </div>
</template>

<script>
import Pagination from "@shared/components/pagination"
import closeApplicationModal from "@ambition/components/closeApplication/closeApplicationModal"
import {Message} from "element-ui"
import LineChart from "./LineChart"
import MixChart from "./MixChart"
import PartnersAssign from "./PartnersAssign"
import BrokersAssign from "./BrokersAssign"
import ZapsAssign from "./ZapsAssign"
import TeamsAssign from "./TeamsAssign"
import LeadsAutoAssigner from "@/components/LeadsAutoAssigner/tenant"
import LeadScoringModal from "./LeadScoringModal";

export default {
    name: "LeadManagement",
    props: {
        tenant: Number,
        teams: Array,
        sources: Array,
        closeReasons: Array,
        brokers: Array,
        referrers: Array,
        dropDownOptions: Object,
        token: String,
        viewAllTeams: Number,
    },
    components: {
        pagination: Pagination,
        closeApplicationModal,
        LineChart,
        MixChart,
        LeadsAutoAssigner,
        PartnersAssign,
        BrokersAssign,
        TeamsAssign,
        LeadScoringModal,
        ZapsAssign,
    },
    data() {
        return {
            otherTeamsHasLeads: false,
            applicationToScore: [],
            leadScoring: [],
            activeTab: 'brokers',
            showStatChart: false,
            referral_data: {},
            selectedChart: false,
            leadScoringModalVisible: false,
            lineChartData: {
                month: {
                    title: "Monthly Statisics",
                    requestedData: [8, 5, 10, 10, 10, 5, 0, 8, 5, 10, 10, 10, 5, 0, 8, 5, 10, 10, 10, 5, 0, 8, 5, 10, 10, 10, 5, 0],
                    receivedData: [8, 8, 10, 10, 10, 8, 5, 8, 5, 10, 10, 10, 5, 0, 10, 5, 10, 10, 10, 10, 0, 8, 5, 10, 10, 10, 5, 5],
                    dataType: "month",
                    data: "2021-02",
                },
                today: {
                    title: "Todays Statisics",
                    requestedData: [100, 120, 161, 134, 105, 160, 165],
                    receivedData: [120, 82, 91, 154, 162, 140, 145],
                    dataType: "day",
                },
            },
            closeApplicationModalVisibility: false,
            closeModal: false,
            closeReasonOptions: [],


            brokerInformation: [],
            rowInformation: null,


            marketingPartner: false,
            opportunties: "unassigned",
            collection: {},
            limit: 10,
            rowId: null,
            selectedLeads: [],
            assignedLeads: [],
            multiSelect: [],
            checked: {},
            openAssignModal: false,
            allSelectToggle: false,
            listLoading: true,
            showFilters: false,
            selectBrokerModal: false,
            leadAction: {
                name: "",
                team: "",
                broker: "",
                partner: "",
                zaps: ""
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: "Last week",
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit("pick", [start, end])
                        },
                    },
                    {
                        text: "Last month",
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit("pick", [start, end])
                        },
                    },
                    {
                        text: "Last 3 months",
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                            picker.$emit("pick", [start, end])
                        },
                    },
                ],
            },
            options: {
                assigned: "Assigned",
                unassigned: "Unassigned",
                user: "My Leads",
                closed: "Closed",
            },
            leadStatuses: {
                Assigned: "success",
                Unassigned: "warning",
                "Rejection Pending": "danger",
            },
            unassignedOptions: [{action: "assign", label: "Assign"}],
            assignedOptions: [
                {action: "reassign", label: "Re-assign"},
                {action: "unassign", label: "Un-assign"},
                {action: "unassignRetract", label: "Un-assign & Retract"},
            ],
            selectedReferrer: "",
            selectedSource: "",
            columns: [],
            listFilters: {
                search: null,
                opportunties: "unassigned",
                teamId: [],
                user: null,
                referrer: null,
                referrer_user: null,
                source: null,
                source_detail: null,
                range: null,
                optionsSelected: [],
            },
            icons: {
                Personal:
                    "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMDIuMSAzMDIuMSI+PGNpcmNsZSBjeD0iMTUxLjA1IiBjeT0iMTUxLjA1IiByPSIxNTEuMDUiIGZpbGw9IiNmZmYiLz48cG9seWdvbiBwb2ludHM9IjE1Ni45IDIzMy44OCAxNDQuMTkgMjMzLjg4IDE0NS42IDY4LjIyIDE1OC4xMSA2OC4yMiAxNTYuOSAyMzMuODgiIGZpbGw9IiNlYzQyOTYiLz48cGF0aCBkPSJNMTQ0LjE5LDIzMy44OGwuMTctMjAuMzNjLTExLjctLjItMjQtMy44OS0zMS04LjkzbDQuODQtMTMuNTJhNTMuODQsNTMuODQsMCwwLDAsMjkuMDYsOC42OGMxNC4zMiwwLDI0LTguMjgsMjQtMTkuNzgsMC0xMS4wOS03Ljg3LTE3Ljk1LTIyLjgtMjQtMjAuNTgtOC4wNy0zMy4zLTE3LjM1LTMzLjMtMzQuOSwwLTE2Ljc1LDExLjkxLTI5LjQ2LDMwLjQ3LTMyLjQ5VjY4LjIyaDEyLjUxVjg3Ljc5YzEyLjExLjQxLDIwLjM4LDMuNjQsMjYuMjMsNy4wN2wtNSwxMy4zMWE0OC44LDQ4LjgsMCwwLDAtMjUuNDMtNi44NmMtMTUuNTMsMC0yMS4zOCw5LjI4LTIxLjM4LDE3LjM2LDAsMTAuNDksNy40NiwxNS43MywyNSwyMywyMC43OCw4LjQ3LDMxLjI3LDE5LDMxLjI3LDM2LjkyLDAsMTUuOTQtMTEuMSwzMC44Ny0zMS44OCwzNC4zdjIxWiIgZmlsbD0iIzQwMzQ4YSIvPjxwb2x5Z29uIHBvaW50cz0iMTQ1LjYxIDY4LjIyIDE1OC4zMSA2OC4yMiAxNTcuODUgMTAzLjg0IDE0NS4zIDEwMy4xNSAxNDUuNjEgNjguMjIiIGZpbGw9IiNlYzQyOTYiLz48cG9seWdvbiBwb2ludHM9IjE1Ni45IDIzMy44OCAxNDQuMTkgMjMzLjg4IDE0NC40OCAxOTkuNjUgMTU3LjE2IDE5OC4yNSAxNTYuOSAyMzMuODgiIGZpbGw9IiNlYzQyOTYiLz48L3N2Zz4=",
                Other:
                    "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMDIuMSAzMDIuMSI+PGNpcmNsZSBjeD0iMTUxLjA1IiBjeT0iMTUxLjA1IiByPSIxNTEuMDUiIGZpbGw9IiNmZmYiLz48cG9seWdvbiBwb2ludHM9IjE1Ni45IDIzMy44OCAxNDQuMTkgMjMzLjg4IDE0NS42IDY4LjIyIDE1OC4xMSA2OC4yMiAxNTYuOSAyMzMuODgiIGZpbGw9IiNlYzQyOTYiLz48cGF0aCBkPSJNMTQ0LjE5LDIzMy44OGwuMTctMjAuMzNjLTExLjctLjItMjQtMy44OS0zMS04LjkzbDQuODQtMTMuNTJhNTMuODQsNTMuODQsMCwwLDAsMjkuMDYsOC42OGMxNC4zMiwwLDI0LTguMjgsMjQtMTkuNzgsMC0xMS4wOS03Ljg3LTE3Ljk1LTIyLjgtMjQtMjAuNTgtOC4wNy0zMy4zLTE3LjM1LTMzLjMtMzQuOSwwLTE2Ljc1LDExLjkxLTI5LjQ2LDMwLjQ3LTMyLjQ5VjY4LjIyaDEyLjUxVjg3Ljc5YzEyLjExLjQxLDIwLjM4LDMuNjQsMjYuMjMsNy4wN2wtNSwxMy4zMWE0OC44LDQ4LjgsMCwwLDAtMjUuNDMtNi44NmMtMTUuNTMsMC0yMS4zOCw5LjI4LTIxLjM4LDE3LjM2LDAsMTAuNDksNy40NiwxNS43MywyNSwyMywyMC43OCw4LjQ3LDMxLjI3LDE5LDMxLjI3LDM2LjkyLDAsMTUuOTQtMTEuMSwzMC44Ny0zMS44OCwzNC4zdjIxWiIgZmlsbD0iIzQwMzQ4YSIvPjxwb2x5Z29uIHBvaW50cz0iMTQ1LjYxIDY4LjIyIDE1OC4zMSA2OC4yMiAxNTcuODUgMTAzLjg0IDE0NS4zIDEwMy4xNSAxNDUuNjEgNjguMjIiIGZpbGw9IiNlYzQyOTYiLz48cG9seWdvbiBwb2ludHM9IjE1Ni45IDIzMy44OCAxNDQuMTkgMjMzLjg4IDE0NC40OCAxOTkuNjUgMTU3LjE2IDE5OC4yNSAxNTYuOSAyMzMuODgiIGZpbGw9IiNlYzQyOTYiLz48L3N2Zz4=",
                Insurance:
                    "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMDIuMSAzMDIuMSI+PGNpcmNsZSBjeD0iMTUxLjA1IiBjeT0iMTUxLjA1IiByPSIxNTEuMDUiIGZpbGw9IiNmZmYiLz48cGF0aCBkPSJNNzMuMSwxMDMuMjRjNC4zMy0xLjQ4LDguNzYtMi43OSwxMy00LjQ5QzEwMS41Niw5Mi42MywxMTYsODQuNDksMTMwLDc1LjY1YzYuNTUtNC4xNCwxMy04LjQ5LDE5LjQtMTIuODVhMi4zOSwyLjM5LDAsMCwxLDMuMjUsMGMxNS41NiwxMC44MywzMS41NiwyMC45NCw0OC41NiwyOS4zNyw4Ljc5LDQuMzcsMTcuNzIsOC4zOSwyNy4zMywxMC43YTMuNTIsMy41MiwwLDAsMSwuNTEuMjZjLS41LDMuNzctMS4wNyw3LjU0LTEuNDksMTEuMzItLjk0LDguMzMtMS42OCwxNi42OS0yLjcxLDI1LTIsMTYuMzQtNSwzMi40OC0xMS40OSw0Ny43My02LjUzLDE1LjQ1LTE2Ljg1LDI4LjA2LTI5LjY3LDM4Ljc4YTM1NS44NSwzNTUuODUsMCwwLDEtMzEuNDEsMjRjLS43My40OC0xLjIyLjktMi4yMy4yNGEzMjAuMjksMzIwLjI5LDAsMCwxLTM2LjMxLTI4LjI3Yy0xNi4yNS0xNC41OC0yNi40MS0zMi43OS0zMS40MS01NGEyNzkuMDgsMjc5LjA4LDAsMCwxLTYuMjItMzlDNzUuMjksMTIwLjM1LDc0LjEsMTExLjgxLDczLjEsMTAzLjI0Wk04MS42MiwxMDljMCwuMzMsMCwuNjEuMDYuODksMSw4LjE1LDIuMTksMTYuMjgsMi45NSwyNC40NmEyMzcuNzksMjM3Ljc5LDAsMCwwLDUuNTYsMzMuMjFjNC40NiwxOC41MSwxMy41MywzNC4zMywyNy42OSw0N2EyNzIuNiwyNzIuNiwwLDAsMCwzMS43LDI0LjcyLDIuMTIsMi4xMiwwLDAsMCwyLjgxLDAsMjkzLjcsMjkzLjcsMCwwLDAsMjkuNzktMjMsODguNDEsODguNDEsMCwwLDAsMjUuNDItMzUuNTYsMTQ3LjE2LDE0Ny4xNiwwLDAsMCw3LjkxLTMxLjhjMS4xNS04LDEuODUtMTYsMi43OC0yNCwuNjMtNS4zMiwxLjMtMTAuNjMsMi0xNi04LjgxLTIuMTUtMTcuMDgtNS44Mi0yNS4xOS05Ljg3YTM0NS41MSwzNDUuNTEsMCwwLDEtNDIuNTQtMjUuNzksMi4zMywyLjMzLDAsMCwwLTMuMTEsMGMtOC44NSw1Ljc2LTE3LjYxLDExLjY2LTI2LjY2LDE3LjA2QzEwOS44Miw5OC4wOSw5Ni40OCwxMDUsODEuNjIsMTA5WiIgZmlsbD0iIzQwMzQ4YSIvPjxyZWN0IHg9IjE0NS45NyIgeT0iMTEzLjUyIiB3aWR0aD0iOS45NCIgaGVpZ2h0PSI2Ni45IiBmaWxsPSIjZWM0Mjk2Ii8+PHJlY3QgeD0iMTQ1Ljk3IiB5PSIxMTMuNTIiIHdpZHRoPSI5Ljk0IiBoZWlnaHQ9IjY2LjkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMuOTcgMjk3LjkxKSByb3RhdGUoLTkwKSIgZmlsbD0iI2VjNDI5NiIvPjwvc3ZnPg==",
                Car: "data:image/svg+xml;base64,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",
                Motorcycle:
                    "data:image/svg+xml;base64,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",
                Boat: "data:image/svg+xml;base64,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",
                Caravan:
                    "data:image/svg+xml;base64,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",
                Truck:
                    "data:image/svg+xml;base64,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",
            },
            dailyTargetModal: false,
            dailyTarget: {
                leads: 0,
                monthlyTopup: 0,
            },
            monthlyTargetModal: false,
            monthlyTarget: {
                leads: 0,
            },
            requestTargetModal: false,
            monthlyTopupTarget: {
                leads: 0,
            },
            hover: false
        }
    },
    computed: {
        assigningSelected() {
            return this.assignedLeads
        },
        filteredBrokers() {
            if (this.leadAction.team) {
                return this.brokers.filter(broker => {
                    if (_.size(broker.teams) && _.size(broker.teams.filter(team => {
                        if (this.leadAction.team == team.id) {
                            return team
                        }
                    }))) {
                        return broker
                    }
                });
            }

            return this.brokers
        },
        filteredTeams() {
            return _.get(window.TenantGlobals, 'user.teams', this.teams);
        },
        averageNaf() {
            if (this.referral_data.goals.monthly.delivered > 0) {
                let averageNaf = this.referral_data.goals.monthly.leads_amount / this.referral_data.goals.monthly.delivered
                return Number(averageNaf).toLocaleString("en-AU", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })
            }
            return Number(0).toLocaleString("en-AU", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
        },
        remaining_leads() {
            let remaining = Number(this.referral_data.goals.monthly.requested) - this.referral_data.goals.monthly.delivered
            this.dailyTarget.remaining = remaining
            this.monthlyTopupTarget.remaining = remaining
            return remaining
        },
        target_low() {
            return ((Number(this.referral_data.goals.monthly.requested) - this.referral_data.goals.monthly.delivered) /
                Number(this.referral_data.goals.monthly.requested)) *
            100 <=
            10
                ? true
                : false
        },
        daily_target() {
            if (this.referral_data.goals.monthly.requested) {
                return Number(
                    (Number(this.referral_data.goals.monthly.requested) - this.referral_data.goals.monthly.delivered) /
                    this.referral_data.workingDaysLeft
                ).toFixed(0)
            }
            return 0
        },
        referrer_users() {
            let users = []
            if (_.has(this.selectedReferrer, "users")) {
                users = _.get(this.selectedReferrer, "users")
                this.listFilters.referrer = _.get(this.selectedReferrer, "id", null)
            } else {
                this.listFilters.referrer = null
            }
            return users
        },
        source_details() {
            let source_details = []
            if (_.has(this.selectedSource, "source_detail")) {
                source_details = _.get(this.selectedSource, "source_detail")
                this.listFilters.source = _.get(this.selectedSource, "id", null)
            } else {
                this.listFilters.source = null
            }
            return source_details
        },
        columnGroups() {
            let teams = []

            if (_.get(Ambition, 'Globals.tenant.teams_enabled')) {
                if (this.viewAllTeams) {
                    const mappedTeams = this.teams.map((team) => {
                        return {
                            value: {type: "team", id: team.id},
                            label: team.name,
                        }
                    })

                    const defaultTeam = [{
                        value: {type: "team", id: null},
                        label: 'Default',
                    }]

                    teams.push({
                        name: "Teams",
                        fields: [...defaultTeam, ...mappedTeams],
                    })
                    console.log('teams enabled', teams)
                } else if (_.size(this.filteredTeams)) {
                    teams.push({
                        name: "Teams",
                        fields: this.filteredTeams.map((team) => {
                            return {
                                value: {type: "team", id: team.id},
                                label: team.name,
                            }
                        }),
                    })
                }
            }

            return [
                ...teams,
                {
                    name: "Brokers",
                    disabled: this.listFilters.opportunties == "assigned" ? false : true,
                    fields: this.brokers.map((broker) => {
                        return {
                            value: {type: "broker", id: broker.id},
                            label: broker.full_name,
                        }
                    }),
                },
                {
                    name: "Referrers",
                    fields: this.referrers.map((referrer) => {
                        let field = {}
                        field = {
                            value: {type: "referrer", id: referrer.id},
                            label: referrer.name,
                        }

                        if (referrer.users.length > 0) {
                            field.children = referrer.users
                                .map((user) => {
                                    return {
                                        value: {type: "referrer_user", id: user.id},
                                        label: user.full_name,
                                    }
                                })
                                .filter((e) => e)
                        }

                        return field
                    }),
                },
                {
                    name: "Source",
                    fields: !_.isEmpty(this.sources) && this.sources.map((source) => {
                        let field = {}
                        field = {
                            value: {type: "source", id: _.get(source, 'id')},
                            label: _.get(source, 'name'),
                        }

                        if (_.size(_.get(source, 'source_detail')) > 0) {
                            field.children = _.get(source, 'source_detail')
                                .map((detail) => {
                                    return {
                                        value: {type: "source_detail", id: detail.id},
                                        label: detail.detail,
                                    }
                                })
                                .filter((e) => e)
                        }

                        return field
                    }),
                },
            ]
        },
        mappedOptions() {
            return this.columnGroups.map((columnGroup) => {
                return {
                    value: columnGroup.name,
                    disabled: _.get(columnGroup, "disabled", false),
                    label: columnGroup.name,
                    children: columnGroup.fields
                        .map((field) => {
                            return {
                                value: field.value,
                                disabled: _.get(columnGroup, "disabled", false),
                                label: field.label,
                                children: _.get(field, "children", null),
                            }
                        })
                        .filter((e) => e),
                }
            })
        },
    },
    created() {
        // this.getStats = _.debounce(this.getStats, 5000)

        this.marketingPartner = _.get(this.Ambition, "Globals.tenant.enable_marketing_partner", false)
        this.getStats()
        this.handleFilter()
        this.closeReasonOptions = this.formatOptions(this.closeReasons)
    },
    mounted() {
        this.storeOptions(_.get(this.dropDownOptions, "loanTypes", []), "options/saveLoanTypes")
        this.storeAssetTypes(_.get(this.dropDownOptions, "assetTypes", []), "options/saveAssetTypes")
        this.storeOptions(_.get(this.dropDownOptions, "sources", []), "options/saveSources")
        this.storeOptions(_.get(this.dropDownOptions, "residentialStatuses", []), "options/saveResidentialStatuses")
        this.storeOptions(_.get(this.dropDownOptions, "sourceDetails", []), "options/saveSourceDetails")

        this.$bus.$on('reload:leadmanagement', () => {
            this.handleFilter();
        })

        this.channel = Echo.private("lead_management.master").listen(
            ".update",
            e => {
                this.handleFilter();
            }
        ).listenForWhisper('change', (e) => {
            this.handleFilter();
        });

        this.$bus.$on("lead::statistics::reload", (data) => {
            this.getStats()
        })
        this.$bus.$on("lead-collection-reload", (data) => {
            this.selectedLeads = [];

            this.listLoading = data.listLoading

            let event = {
                page: 1,
                limit: _.get(this.collection, "per_page", this.limit),
            }
            this.getCollection(event)
        })

        const onListen = _.debounce(async (e) => {
            this.getStats()
            if (_.get(this.listFilters, "opportunties", "") == "unassigned") {
                this.handleFilter()
            }
        }, 5000)

        const onListenForWhisper = _.debounce(async (e) => {
            if (_.get(this.listFilters, "opportunties", "") == "unassigned") {
                this.handleFilter()
            }
        }, 5000)

        // build echo endpoint to auto load leads in tenant
        Echo.private("lead_management_tab." + this.tenant)
            .listen(".update", onListen)
            .listenForWhisper("change", onListenForWhisper)

        if (Ambition.getGlobal("tenant.user.user_settings.disable_card_view_hover") == "yes") {
            this.hover = true
        }
    },
    watch: {
        "closeApplicationModalVisibility"(value) {
            if (!value) {
                this.clearSelection()
                this.selectedLeads = []
            }
        },
        "listFilters.referrer"(newVal, oldVal) {
            this.handleFilter(true)
        },
        "listFilters.source"(newVal, oldVal) {
            this.handleFilter(true)
        },
        opportunties(newVal, oldVal) {
            this.opportunties = newVal
            this.$store.commit("leadTable/SET_CUSTOM_FILTER", {filter: "opportunties", value: newVal})
        },
        tenantId(newVal, oldVal) {
            this.tenantId = newVal
            this.$store.commit("leadTable/SET_CUSTOM_FILTER", {filter: "tenantId", value: newVal})
        },
        limit(newVal, oldVal) {
            this.options.perPage = newVal
        },
        multiSelect(newVal, oldVal) {
            this.selectedLeads = []
            newVal.forEach((value) => {
                this.selectedLeads.push(value)
            })
        },
        allSelectToggle(newVal, oldVal) {
            if (newVal) {
                let data = []
                this.data.forEach((lead) => {
                    if (!lead.tenant) {
                        data.push({
                            id: lead.id,
                            amount: lead.amount,
                        })
                    }
                })
                this.multiSelect = data
            } else {
                this.multiSelect = []
            }
        }
    },
    beforeCreate() {
    },
    beforeDestroy() {
        this.$bus.$off("lead::statistics::reload")
        this.$bus.$off("lead-collection-reload")
        this.$bus.$off("reload:leadmanagement")
    },
    methods: {
        checkSameDay(datetime) {
            return datetime ? this.$moment(datetime).isSame(this.$moment(), 'day') : false
        },
        createNote(application) {
            this.$emit("create-note", application)
        },
        storeOptions: function (data, action) {
            let optionList = []
            data.map((element) => {
                optionList.push({
                    label: element.name,
                    value: element.id,
                    name: _.camelCase(element.name),
                })
            })

            this.$store.dispatch(action, optionList)
        },
        storeAssetTypes(data, action) {
            let optionList = [];
            data.map(element => {
                optionList.push({
                    label: _.get(element, "label", _.get(element, "name")),
                    name: _.get(element, "label", _.get(element, "name")),
                    value: _.get(element, "id", _.get(element, "value")),
                    subTypes: _.get(element, "asset_subcategories"),
                })
            });

            this.$store.dispatch(action, optionList);
        },
        toggleLeadSocringModal() {
            this.leadScoringModalVisible = true
        },
        toggleFilters() {
            this.showFilters = !this.showFilters
        },
        setData(res) {
            this.$set(this.$data, "collection", res.data.collection)
            this.listLoading = false
        },
        handleFilter(loading = false) {
            let collection = this.collection
            if (loading) {
                this.listLoading = true
            }
            let event = {
                page: 1,
                limit: _.get(collection, "per_page", this.limit),
            }
            this.getCollection(event)
        },
        getStats() {
            this.$tenant
                .post(`/api/lead-management/stats`, {
                    currentTeamId: _.get(this.Ambition, "Globals.tenant.currentTeamId", false),
                })
                .then((res) => {
                    this.$set(this.$data, "referral_data", res.data.referral_data)
                })
        },
        handleActionButtonClick(e) {
            e.stopPropagation()
        },
        getCollection(event) {
            if (_.get(event, "loading")) {
                this.listLoading = true
            }

            this.$tenant
                .post(`/api/lead-management`, {
                    currentTeamId: _.get(this.Ambition, "Globals.tenant.currentTeamId", false),
                    page: event.page,
                    per_page: event.limit,
                    ...this.listFilters,
                })
                .then((res) => {
                    this.$set(this.$data, "collection", res.data.collection)
                    if (res.data.count > 0) {
                        this.otherTeamsHasLeads = true
                    }
                    this.assignedLeads = []
                    this.$set(this.$data, "applicationToScore", res.data.applicationToScore)
                    this.$set(this.$data, "leadScoring", res.data.leadScoring)

                    this.listLoading = false
                })
        },
        clear() {
            this.clearSelection()
            this.multiSelect = [],
            this.selectedLeads = []
            this.leadAction.name = ""
            this.leadAction.broker = ""
            this.leadAction.team = ""
            this.leadAction.partner = ""
            this.leadAction.zaps = ""
        },
        clearSelection() {
            this.$refs.filterTable.clearSelection()
        },
        handleSelectionChange(val) {
            let data = {}

            this.selectedLeads = val
            val.forEach((row) => {
                return (data[row.id] = true)
            })

            this.checked = data
        },
        selectable(row) {
            return !_.size(_.filter(this.assigningSelected, ['id', row.id]));
        },
        updatedLead(lead) {
            let channel = Echo.private("lead_management.master")
            channel.whisper("change", {lead})
        },
        setStatus(command) {
            switch (command.action) {
                case "assign":
                    this.leadAction.name = "assign"
                    this.selectBrokerModal = true
                    this.leadAction.team = _.get(this.Ambition, "Globals.tenant.currentTeamId", "")
                    this.selectedLeads = [command.row]
                    break
                case "reassign":
                    this.leadAction.name = "reassign"
                    this.leadAction.team = _.get(this.Ambition, "Globals.tenant.currentTeamId", "")
                    this.selectBrokerModal = true
                    this.selectedLeads = [command.row]
                    break
                case "unassign":
                    this.unassign(command.row)
                    break
                case "unassignRetract":
                    this.unassign(command.row, true)
                    break
            }
        },
        showBrokerSelect() {
            this.leadAction.name = this.listFilters.opportunties == "assigned" ? "reassign" : "assign"
            this.leadAction.team = _.get(this.Ambition, "Globals.tenant.currentTeamId", "")
            this.selectBrokerModal = true
        },
        closeBrokerModal() {
            this.clearSelection()
            this.selectedLeads = []
            this.leadAction.name = ""
            this.leadAction.broker = ""
            this.leadAction.team = ""
            this.leadAction.zaps = ""
            this.leadAction.partner = ""
            this.selectBrokerModal = false
        },
        submitAction() {
            switch (this.leadAction.name) {
                case "assign":
                    this.selectBrokerModal = false
                    this.assignSelected()
                    break
                case "reassign":
                    this.selectBrokerModal = false
                    this.reassignSelected(this.leadAction.broker)
                    break
                case "unassign":
                    this.unassign(command.row)
                    break
                case "reject":
                    break
            }
        },
        addData(data) {
        },
        assignSelected() {
            this.assignedLeads = _.cloneDeep(this.selectedLeads)

            this.$tenant
                .post(`/api/lead-management/assign`, {
                    broker: this.leadAction.broker,
                    team: this.leadAction.team,
                    opportunities: this.selectedLeads,
                    partner: this.leadAction.partner,
                    zaps: this.leadAction.zaps
                })
                .then((response) => {
                    const multi = _.size(_.get(response, 'data.opportunities')) > 1 ? 'Opportunities' : 'Opportunity';
                    if (_.get(response, 'data.zap')) {
                        Message({
                            message: `${multi} added to zap queue successfully.`,
                            type: "success",
                        })
                    } else {
                        Message({
                            message: `${multi} assigned successfully.`,
                            type: "success",
                        })
                    }
                    this.handleFilter()
                })
                .catch((error) => {
                    this.clear()

                    Message({
                        message: error.message,
                        type: "error",
                    })
                })

            this.clear()
        },
        reassignSelected(broker) {
            this.$tenant
                .post(`/api/lead-management/reassign/${broker}`, {
                    opportunities: this.selectedLeads,
                })
                .then((response) => {
                    Message({
                        message: "Opportunity reassigned successfully.",
                        type: "success",
                    })
                    this.handleFilter()
                })
                .catch((error) => {
                    this.clear()
                    Message({
                        message: error.message,
                        type: "error",
                    })
                })
            this.clear()
        },
        unAssignAndRetractSelectedLeads() {
            this.unAssignSelectedLeads(true)
        },
        unAssignSelectedLeads(retract = false) {
            if (this.selectedLeads.length > 0) {
                this.$tenant
                    .post(`/api/lead-management/unassign-multiple`, {
                        leads: _.map(this.selectedLeads, "id"),
                        retract,
                    })
                    .then((response) => {
                        Message({
                            message: "Opportunities unassigned successfully.",
                            type: "success",
                        })
                        this.clearSelection()
                        this.selectedLeads = []
                        this.handleFilter()
                    })
                    .catch((error) => {
                        Message({
                            message: error.message,
                            type: "error",
                        })
                    })
            }
        },
        unassign(lead, retract = false) {
            this.$tenant
                .post(`/api/lead-management/unassign/${lead.id}`, {
                    retract,
                })
                .then((response) => {
                    Message({
                        message: "Opportunity unassigned successfully.",
                        type: "success",
                    })

                    this.clearSelection()
                    this.selectedLeads = []
                    this.handleFilter(true)

                    this.$bus.$emit('reload:leadmanagement')
                    this.$bus.$emit("lead::statistics::reload")
                    this.$bus.$emit("lead-collection-reload")
                })
                .catch((error) => {
                    Message({
                        message: error.message,
                        type: "error",
                    })
                })
        },
        loanTypeBadge(row) {
            let re = new RegExp(/(commercial)/, "igm")
            let campaignMatches = re.exec(row.campaign_name)
            let adminDataMatches

            if (row.admin_additional_data) {
                adminDataMatches = re.exec(row.admin_additional_data)
            }

            return _.has(campaignMatches, "1") ? "Commercial" : _.has(adminDataMatches, "1") ? "Commercial" : "Consumer"
        },
        formatOptions(data) {
            let self = this
            let options = []

            data.map((element) => {
                options.push({label: element.name, value: element.id})
            })

            return options
        },
        formatCurrency(amount, decimals = 0) {
            let currencyFormatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals,
            })
            return currencyFormatter.format(amount)
        },
        closeApplications() {
            this.closeApplicationModalVisibility = true
        },
        setDailyTarget() {
            this.dailyTargetModal = true
            this.$nextTick((_) => {
                this.$refs.dailyTarget.$refs.input.focus()
            })
        },
        handleDailyTarget() {
            this.$tenant
                .post(`/api/lead-management/request/set-leads`, {
                    ...this.dailyTarget,
                })
                .then((response) => {
                    this.dailyTargetModal = false
                    Message({
                        message: "Lead target set for tomorrow",
                        type: "success",
                    })
                })
                .catch((error) => {
                    Message({
                        message: error.message,
                        type: "error",
                    })
                })
        },
        setMonthlyTarget() {
            this.monthlyTargetModal = true
            this.$nextTick((_) => {
                this.$refs.monthlyTarget.$refs.input.focus()
            })
        },
        handleMonthlyTarget() {
            this.$tenant
                .post(`/api/lead-management/request/set-monthly-leads`, {
                    ...this.monthlyTarget,
                })
                .then((response) => {
                    this.monthlyTargetModal = false
                    Message({
                        message: "Lead target set for next month",
                        type: "success",
                    })
                })
                .catch((error) => {
                    Message({
                        message: error.message,
                        type: "error",
                    })
                })
        },
        requestTargetTopup() {
            this.requestTargetModal = true
            this.$nextTick((_) => {
                this.$refs.monthlyTopupTarget.$refs.input.focus()
            })
        },
        handleTargetTopup() {
            this.$tenant
                .post(`/api/lead-management/request/topup`, {
                    ...this.monthlyTopupTarget,
                })
                .then((response) => {
                    this.requestTargetModal = false
                    Message({
                        message: "Lead top-up request has been lodged, on approval will be applied",
                        type: "success",
                    })
                })
                .catch((error) => {
                    Message({
                        message: error.message,
                        type: "error",
                    })
                })
        },
        checkSameDay(datetime) {
            return datetime ? this.$moment(datetime).isSame(this.$moment(), "day") : false
        },

    },
}
</script>
<style lang="scss">
.table-scrollbar {
    position: relative;
    height: auto;
    max-height: 230px;
    overflow-y: auto;
}

.table-wrapper-scroll-y {
    display: block;
}

.tableFixHead {
    thead th {
        position: sticky;
        top: 0;
        z-index: 1;
        background: #fff;
    }
}

.el-date-editor .el-range-separator {
    padding: 0 5px;
    line-height: 32px;
    width: 10%;
    color: #303133;
}

.lead-stats {
    .box-card {
        .el-card__header {
            font-weight: 600;
            color: #7d7d7d;

            .el-tag {
                font-weight: 400;
            }
        }

        .el-card__body {
            padding: 0px !important;

            h2 {
                padding: 20px;
                color: #797979 !important;
                text-align: center;
            }

            .split-content {
                display: flex;
                width: 100%;
                justify-content: space-around;
                align-items: center;

                .left {
                    flex-grow: 1;
                    align-items: center;
                    justify-content: center;
                    display: flex;
                    padding: 20px;

                    h2 {
                        padding: 0px;
                        color: #797979 !important;
                    }
                }

                .right {
                    flex-grow: 1;
                    align-items: center;
                    justify-content: center;
                    display: flex;
                    padding: 20px;
                    clip-path: polygon(17% 0%, 100% 0%, 100% 100%, 0% 100%);
                    background: #68c23a;

                    h2 {
                        padding: 0px;
                        color: #fff !important;
                    }
                }
            }
        }
    }
}

.admin-additional-data {
    background: #f1f1f1 !important;
    min-width: 12.5rem;
}

.table td {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
}

.table th.no-padding {
    padding-left: 0rem !important;
    padding-right: 0rem !important;
}

.lead-manager {
    &.el-table {
        th,
        td {
            font-size: smaller !important;

            p {
                font-size: smaller !important;
            }
        }

        td {
            .el-badge {
                margin: 0.5rem !important;
            }
        }
    }

    .warning-row {
        background-color: #ffeaea;
    }
}

.filters-dropdown {
    background: #e7e7e7;
    border: 0px;
    border-radius: 0px;
    margin-bottom: 15px;
}

.filters-dropdown .panel {
    background: transparent !important;
    border: none !important;
}
</style>
